// ============================================================
// sistema.js — de que aparelho veio o acesso
//
// Usado para orientar o atleta de Android a usar o aplicativo em vez do
// portal. NÃO é controle de segurança: o navegador informa isso num
// cabeçalho que qualquer pessoa troca em dois cliques nas ferramentas de
// desenvolvedor. Serve para o caso comum, que é comodidade, não fraude.
//
// A lógica é DETECTAR ANDROID, não detectar iOS, e essa escolha é o que
// dá a garantia de não derrubar quem está no iPhone ou iPad:
//
//   - "Android" aparece de forma inequívoca no identificador do navegador.
//   - iOS, não. Desde o iPadOS 13 o iPad se identifica como "Macintosh"
//     por padrão, então uma regra do tipo "só passa quem parecer iOS"
//     barraria iPads legítimos. Já uma regra "barra quem for Android"
//     deixa passar iPhone, iPad em qualquer modo, computador e qualquer
//     aparelho que não se declare Android.
//
// Em caso de dúvida, libera. Bloquear um atleta que veio treinar é pior
// do que deixar passar um registro pelo portal.
// ============================================================

export function ehAndroid(userAgent) {
  const ua = userAgent !== undefined
    ? userAgent
    : (typeof navigator !== "undefined" ? navigator.userAgent : "");

  return /android/i.test(String(ua || ""));
}

// Só para texto de tela: identifica o iPhone/iPad quando dá, sem depender
// disso para liberar nada.
export function pareceIOS(userAgent) {
  const ua = String(
    userAgent !== undefined
      ? userAgent
      : (typeof navigator !== "undefined" ? navigator.userAgent : "")
  );
  if (ehAndroid(ua)) return false;
  if (/iPhone|iPad|iPod/i.test(ua)) return true;
  // iPad em modo desktop: diz "Macintosh", mas tem tela sensível ao toque.
  const macComToque =
    /Macintosh/i.test(ua) &&
    typeof navigator !== "undefined" &&
    Number(navigator.maxTouchPoints || 0) > 1;
  return macComToque;
}
